import { defineTemplate } from '@/core/define';

export default defineTemplate({
    theme: () => import(/* webpackChunkName: "theme-template1" */ './theme.scss'),
    exclude: ['luckyDraw', 'walletTransfer']
});
